import { FC, useState, ChangeEvent, useEffect } from 'react';
import { useStyles } from './styles';
import { Grid, Paper, Tabs, Tab, IconButton } from '@material-ui/core';
import TabPanel from 'components/TabPanel';
import { GroupObjectForm } from './SubForms';
import { useHistory } from 'react-router-dom';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { handleCompanyUrl } from 'utils/organizationUtils';
function a11yProps(index: string) {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  };
}
export const GroupForm: FC<any> = ({ type }) => {
  const classes = useStyles();
  const [value, setValue] = useState<string>('one');
  const history = useHistory();
  const [CurrentGroup, setCurrentGroup] = useState<any>(() => {
    if (history.location.pathname.split('/')[3] === 'add') {
      localStorage.removeItem('CurrentGroup');
      return null;
    }
    return JSON.parse(localStorage.getItem('CurrentGroup') as string);
  });
  useEffect(() => {
    if (history.location.pathname.split('/')[3] !== 'add') {
      const timeoutId = setTimeout(() => {
        setCurrentGroup(JSON.parse(localStorage.getItem('CurrentGroup') as string));
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
    return undefined;
  }, [history.location.pathname]);
  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
  };
  return (
    <Grid item xl className={classes.tabsPanel}>
      <Paper className={classes.tabsPaper}>
        <div className={classes.left}>
          <IconButton
            onClick={() => {
              history.push(handleCompanyUrl('/groups'));
            }}
          >
            <ChevronLeftIcon />
          </IconButton>
          <Tabs
            value={value}
            indicatorColor='secondary'
            textColor='secondary'
            onChange={handleChange}
            className={classes.tabs}
          >
            <Tab
              value='one'
              label={CurrentGroup?.cn ? `GROUP: ${CurrentGroup.cn}` : 'GROUP'}
              {...a11yProps('one')}
              className={classes.label}
            />
          </Tabs>
        </div>
        <div className={classes.tabBox}>
          <TabPanel value={value} index='one'>
            <GroupObjectForm type={type} currentGroup={CurrentGroup} />
          </TabPanel>
        </div>
      </Paper>
    </Grid>
  );
};
